/**
 * The wall allowance gauge's words, pure so a check can pin them (tools/checks/wall-left-label.mts).
 *
 * "1h 20m left at 9 tiles" — the remainder divided by the tiles playing, then the tile
 * count it was divided by, so the trade reads in one line: fewer tiles, more clock. The
 * clock is coarse on purpose and keeps the gauge's long-standing shape — two-digit minutes
 * beside hours ("2h 00m", "1h 05m"), no hours under one ("45m"), "<1m" at the very end.
 * With nothing playing (paused, zero tiles) there is no divisor to name, so the count drops
 * and the full remainder reads alone ("16h 00m left").
 */

/** "3h 12m" / "48m" / "<1m" — clock time, coarse on purpose. */
export function wallClock(seconds: number): string {
  const m = Math.floor(Math.max(0, seconds) / 60);
  if (m < 1) return "<1m";
  const h = Math.floor(m / 60);
  return h > 0 ? `${h}h ${String(m % 60).padStart(2, "0")}m` : `${m}m`;
}

/** "1h 20m left at 9 tiles" / "45m left at 1 tile" / "16h 00m left" (no tiles playing). */
export function wallLeftLabel(perTileSeconds: number, tiles: number): string {
  const time = `${wallClock(perTileSeconds)} left`;
  return tiles > 0 ? `${time} at ${tiles} ${tiles === 1 ? "tile" : "tiles"}` : time;
}
